import type {GenerationKind, GenerationPricing} from './types.js';

/** Product-planning placeholders for local simulation, not a provider quote. */
export const DEMO_PRICING = Object.freeze({
  imageCredits: 1,
  initialCredits: 200,
  label: 'Demo estimates · pricing is provisional',
  videoCreditsPerSecond: 4
});

export const estimateGenerationCredits = (
  kind: GenerationKind,
  duration = 5,
  pricing: GenerationPricing = DEMO_PRICING
): number => {
  if(!Number.isSafeInteger(pricing.imageCredits) || pricing.imageCredits <= 0
    || !Number.isSafeInteger(pricing.videoCreditsPerSecond) || pricing.videoCreditsPerSecond <= 0) {
    throw new RangeError('Generation rates must be positive integer credits.');
  }

  if(kind === 'image') {
    return pricing.imageCredits;
  }

  if(!Number.isFinite(duration) || duration < 4 || duration > 30) {
    throw new RangeError('Video duration must be at least 4 and at most 30 seconds.');
  }

  const credits = Math.ceil(duration * pricing.videoCreditsPerSecond);
  if(!Number.isSafeInteger(credits)) {
    throw new RangeError('Generation estimate exceeds supported credit precision.');
  }

  return credits;
};

export const formatCredits = (credits: number): string => {
  if(!Number.isSafeInteger(credits) || credits < 0) {
    throw new RangeError('Credits must be a non-negative integer.');
  }

  return `${credits.toLocaleString('en-US')} ${credits === 1 ? 'credit' : 'credits'}`;
};
